import config from '../config';

export function authHeader() {
    return { 'X-API-Key': config.apiKey };
}